// LUT (§11.6): import `.cube` files (1D/3D), choose one for the photo, intensity, remove.
import { useEffect, useState } from 'react';
import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useT } from '../../i18n';
import { deleteLut, importCube, refreshLuts, useLuts } from '../../features/lut/store';

export function LutPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const list = useLuts((s) => s.list);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => void refreshLuts(), []);

  const pick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.cube';
    input.onchange = async () => {
      const f = input.files?.[0];
      if (!f) return;
      try {
        const id = await importCube(f.name, await f.text());
        setError(null);
        update((s) => void (s.lut = { id, intensity: s.lut.intensity || 100 }));
      } catch (e) {
        setError(t('lutError', { name: f.name, reason: (e as Error).message }));
      }
    };
    input.click();
  };

  return (
    <div>
      <button data-testid="lut-import" onClick={pick} style={{ marginBottom: 6 }}>
        {t('lutImport')}
      </button>
      {error && (
        <div style={{ color: '#ff6b6b', fontSize: 12, marginBottom: 6 }} data-testid="lut-error">
          {error}
        </div>
      )}
      <select
        data-testid="lut-select"
        value={settings.lut.id ?? ''}
        onChange={(e) => update((s) => void (s.lut.id = e.target.value || null))}
        style={{ width: '100%', marginBottom: 6 }}
      >
        <option value="">{t('lutNone')}</option>
        {list.map((l) => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </select>
      <Slider
        label="lutIntensity"
        testId="slider-lut-intensity"
        value={settings.lut.intensity}
        min={0}
        max={100}
        step={1}
        defaultValue={100}
        onChange={(v, f) => update((s) => void (s.lut.intensity = v), f)}
      />
      {settings.lut.id && (
        <button
          style={{ marginTop: 6 }}
          onClick={() => {
            const id = settings.lut.id!;
            update((s) => void (s.lut.id = null));
            void deleteLut(id);
          }}
        >
          {t('lutDelete')}
        </button>
      )}
    </div>
  );
}
